<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title></ion-title>
    <ion-buttons slot="end">
      <ion-button color="light" (click)="logout()">
        <ion-icon name="log-out"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen>
  <div class="centered">
    <ion-icon name="mail-open"></ion-icon>
    <p>
      Favor de checar y confirmar su correo electrónico {{user?.email}} y volver a la aplicación. El correo pudo haber
      llegado a la carpeta de correo no deseado o spam.
    </p>
    <ion-button shape="round" fill="outline" color="light" (click)="resend()">Reenviar correo</ion-button>
  </div>
</ion-content>
